import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    nameOfProductionBusinessActivities,
    addressWard,
    addressDistrict,
    addressCity,
    address,
    addressEstate,
    addressCityEstate,
    addressDistrictEstate,
    addressWardEstate,
    contract,
    contractDate,
    notarizedDate,
    taxAgentName,
    taxAgentId,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [nameOfProductionBusinessActivities.name]: Yup.string().required(
    nameOfProductionBusinessActivities.errorMsg
  ),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [addressWard.name]: Yup.string().required(addressWard.errorMsg),
  [addressDistrict.name]: Yup.string().required(addressDistrict.errorMsg),
  [addressCity.name]: Yup.string().required(addressCity.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [addressEstate.name]: Yup.string().required(addressEstate.errorMsg),
  [addressCityEstate.name]: Yup.string().required(addressCityEstate.errorMsg),
  [addressDistrictEstate.name]: Yup.string().required(addressDistrictEstate.errorMsg),
  [addressWardEstate.name]: Yup.string().required(addressWardEstate.errorMsg),
  [contract.name]: Yup.string().required(contract.errorMsg),
  [contractDate.name]: Yup.string().required(contractDate.errorMsg),
  [notarizedDate.name]: Yup.string().required(notarizedDate.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .notRequired(taxAgentId.errorMsg),
});

export default validation;
